//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'swiper/dist/css/swiper.css'
import {swiper,swiperSlide} from 'vue-awesome-swiper';
import readData from '../../testdata/read';
import {mapActions} from 'vuex';
import force from '../../common/forceLandscape';

let timer=null;
export default {
      name: "topic",
    components:{
      swiper,
      swiperSlide
    },
    data(){
        return{
          swiperOptions:{
            noSwiping:true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on:{
              slideChange: ()=>{
                this.index=this.$refs.swiper.swiper.activeIndex;
              },
            },
          },
          index:0,
          readData:[],
          buildData:[],
          error:0,
          zhengque:0,
          leftTime:20,
          recording:false
        }
    },
    methods:{
      ...mapActions(['changeTestStatus']),
      shuffle(){
        this.readData.sort(()=>{
          return Math.random()-0.5;
        })
        return Promise.resolve('success');
      },
      checkAnswer(res){
        var swiperindex=this.$refs.swiper.swiper.activeIndex;
        if(!res){
          this.$vux.toast.text('回答错误','center');
          this.error++;
          if(this.error>=5){
            this.changeTestStatus({name:'read',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
              this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
            });
          }
        }else{
          this.zhengque++;
          this.$vux.toast.text('回答正确','center');
        }
        if(swiperindex>=7){
          this.changeTestStatus({name:'read',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
            this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
          });
        }
        this.$refs.swiper.swiper.slideTo(swiperindex+1);
      },
      record(spot) {
        this.leftTime=20;
        if(!this.recording){
          this.$wechat.startRecord();
          timer=setInterval(()=>{
            this.leftTime--;
            this.$vux.toast.text('录音剩余'+this.leftTime+'秒', ' top');
            if(this.leftTime<=0){
              this.stop();
              clearInterval(timer);
            }
          },1000)
        }else{
          this.stop(spot);
        }
        this.recording=!this.recording;

      },

      stop(spot){
        clearInterval(timer);
        var swiperindex = this.$refs.swiper.swiper.activeIndex;
        this.$wechat.stopRecord({
          success: (res) => {
            console.log(res);
            this.$wechat.uploadVoice({
              localId: res.localId,
              success: (res2) => {
                console.log(res2.serverId);
                this.axios.post('/checkAudio.php', {serverid: res2.serverId, text: spot}).then(res3 => {
                  if(res3.data.data.score>=6.0){
                    this.zhengque++;
                    this.$vux.toast.text('回答正确','middle');
                  }else{
                    this.error++;
                    this.$vux.toast.text('回答错误','middle');
                  }

                  if(this.error>=5){
                    this.changeTestStatus({name:'read',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
                      this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
                    });
                  }
                  console.log(swiperindex);
                  if(swiperindex>=7){
                    this.changeTestStatus({name:'read',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
                      this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
                    });
                  }
                  this.$refs.swiper.swiper.slideTo(swiperindex+1);
                })
              }
            })
          }
        })
      }
    },
    created() {
      var routename=this.$route.name;
      var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
      var index=tixing.indexOf(routename);
      var title=`Test ${index+1} ${this.$store.state.title['lv'+this.$store.state.testLevel][index]}`;
      document.title=title;
      this.readData=readData['lv'+this.$store.state.testLevel];
      this.shuffle().then(_=>{
        this.buildData=this.readData.splice(0,8);
      })
    },
    mounted() {
        force();
    }
}



// WEBPACK FOOTER //
// ./src/components/read/read.vue